import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { logout } from '../utils/auth';
import './Sidebar.css';

function Sidebar({ isOpen, onClose }) {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      path: '/dashboard',
      label: 'Dashboard',
      icon: '📊',
      color: '#f3c855'
    },
    {
      path: '/products',
      label: 'Products',
      icon: '📦',
      color: '#9ca3af'
    },
    {
      path: '/coupons',
      label: 'Coupons',
      icon: '🎫',
      color: '#f3c855'
    },
    {
      path: '/shipstation-orders',
      label: 'Shipstation Orders',
      icon: '🚚',
      color: '#9ca3af'
    }
  ];

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const handleNavClick = (path) => {
    navigate(path);
    // Close sidebar on mobile after navigation
    if (window.innerWidth <= 768) {
      onClose();
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <>
      <div 
        className={`sidebar-overlay ${isOpen ? 'active' : ''}`} 
        onClick={handleOverlayClick}
      ></div>
      <div className={`sidebar ${isOpen ? 'active' : ''}`}>
        <button className="close-btn" onClick={onClose}>×</button>
        
        <div className="brand-section">
          <div className="logo-container">
            <img 
              src="https://rpomeds.myshopify.com/cdn/shop/files/ChatGPT_Image_Jul_21_2025_12_14_42_PM_200x.png?v=1753396493" 
              alt="RpoMeds Logo" 
              className="brand-logo"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div className="logo-fallback" style={{ display: 'none' }}>
              <span className="logo-text">RpoMeds</span>
            </div>
          </div>
          <h2 className="brand-text">RpoMeds</h2>
          <p className="brand-subtitle">Admin Panel</p>
        </div>

        <div className="nav-section">
          <div className="nav-title">Navigation</div>
          {menuItems.map((item) => (
            <button
              key={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => handleNavClick(item.path)}
              style={{ '--item-color': item.color }}
            >
              <div className="nav-icon-wrapper">
                <span className="nav-icon">{item.icon}</span>
              </div>
              <span className="nav-text">{item.label}</span>
              <div className="nav-indicator"></div>
            </button>
          ))}
        </div>

        <div className="user-section">
          <div className="user-info">
            <div className="user-avatar">A</div>
            <div className="user-details">
              <div className="user-name">Admin User</div>
              <div className="user-role">Administrator</div>
            </div>
          </div>
          <button className="logout-btn" onClick={handleLogout}>
            <span>🚪</span>
            <span>Logout</span>
          </button>
        </div>
      </div>
    </>
  );
}

export default Sidebar; 